import React from 'react';
import SVGLoader from './SVGLoader';

const CirclePlayIcon = ({ ...rest }) => {
  return (
    <SVGLoader viewboxHeight={40} viewboxWidth={40} {...rest}>
      <circle cx="20" cy="20" r="20" fill="currentColor" fillOpacity="0.5" />
      <path
        d="M31.2833 17.8415L13.875 9.13319C13.6767 9.03542 13.4568 8.98981 13.236 9.00069C13.0153 9.01156 12.8009 9.07856 12.6132 9.19534C12.4255 9.31212 12.2707 9.47484 12.1634 9.6681C12.0561 9.86137 11.9999 10.0788 12 10.2999V27.6999C11.9999 27.9209 12.0561 28.1383 12.1634 28.3316C12.2707 28.5249 12.4255 28.6876 12.6132 28.8044C12.8009 28.9212 13.0153 28.9882 13.236 28.999C13.4568 29.0099 13.6767 28.9643 13.875 28.8665L31.2833 20.1582C31.4995 20.0515 31.6815 19.8865 31.8087 19.6818C31.936 19.4771 32.0035 19.2409 32.0035 18.9999C32.0035 18.7588 31.936 18.5226 31.8087 18.3179C31.6815 18.1132 31.4995 17.9482 31.2833 17.8415Z"
        fill="currentColor"
      />
    </SVGLoader>
  );
};

export default CirclePlayIcon;
